/**
 * @generated SignedSource<<097b6efd934b5045980af62c13bd4001>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CardBrand = "AMERICAN_EXPRESS" | "CHINA_UNIONPAY" | "DISCOVER" | "DISCOVER_DINERS" | "EBT" | "EFTPOS" | "FELICA" | "INTERAC" | "JCB" | "MASTERCARD" | "OTHER_BRAND" | "SQUARE_CAPITAL_CARD" | "SQUARE_GIFT_CARD" | "UNKNOWN" | "VISA";
export type UpdateDefaultSquareCardOnFileInput = {
  squareCardId: string;
};
export type useSetDefaultCardOnFileMutation$variables = {
  input: UpdateDefaultSquareCardOnFileInput;
};
export type useSetDefaultCardOnFileMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string;
    } | null | undefined>;
    readonly success: boolean;
    readonly user: {
      readonly squareCards: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly cardBrand: CardBrand;
            readonly enabled: boolean;
            readonly id: string;
            readonly lastFour: string;
            readonly " $fragmentSpreads": FragmentRefs<"SelectedPaymentMethodFragment" | "SquareCardFragment">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSetDefaultCardOnFileMutation = {
  response: useSetDefaultCardOnFileMutation$data;
  variables: useSetDefaultCardOnFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v3 = {
  "alias": "message",
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": true
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardBrand",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastFour",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetDefaultCardOnFileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpdateDefaultSquareCardOnFilePayload",
        "kind": "LinkedField",
        "name": "updateDefaultSquareCardOnFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "SquareCardOnFileConnection",
                "kind": "LinkedField",
                "name": "squareCards",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SquareCardOnFileEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareCardOnFile",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SquareCardFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SelectedPaymentMethodFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "squareCards(enabled:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetDefaultCardOnFileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpdateDefaultSquareCardOnFilePayload",
        "kind": "LinkedField",
        "name": "updateDefaultSquareCardOnFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "SquareCardOnFileConnection",
                "kind": "LinkedField",
                "name": "squareCards",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SquareCardOnFileEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareCardOnFile",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "default",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberPackageConnection",
                            "kind": "LinkedField",
                            "name": "memberPackages",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "count",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "squareCards(enabled:true)"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ab1ff87264b0af2cb1fe7dd7fcbdbe80",
    "id": null,
    "metadata": {},
    "name": "useSetDefaultCardOnFileMutation",
    "operationKind": "mutation",
    "text": "mutation useSetDefaultCardOnFileMutation(\n  $input: UpdateDefaultSquareCardOnFileInput!\n) {\n  responsePayload: updateDefaultSquareCardOnFile(input: $input) {\n    errors {\n      __typename\n      field\n      message: code\n    }\n    success\n    user {\n      squareCards(enabled: true) {\n        edges {\n          node {\n            id\n            cardBrand\n            lastFour\n            enabled\n            ...SquareCardFragment\n            ...SelectedPaymentMethodFragment\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment SelectedPaymentMethodFragment on SquareCardOnFile {\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n  user {\n    id\n  }\n  memberPackages {\n    count\n  }\n}\n\nfragment SquareCardFragment on SquareCardOnFile {\n  __typename\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n}\n"
  }
};
})();

(node as any).hash = "48a0448fb7d3dac387641d5a1b3f2fff";

export default node;
